import { h, Fragment } from 'preact';
import { NewPopupModal, NewPopupModalBody } from '../../components/newPopupModal';
import CoreEntityDynamicFormNoModal from '../../components/coreEntityDynamicFormNoModal';

const CoreEntityDynamicForm = (props) => {
  // Main form props data to get from processMapping
  /*
    - formOperation
    - formEntityName
    - formEntityObject
    - setFormEntityObject
    - formDynamicProps
  */
  let {
    operation,
    toggleFormPopover,
    backgroundColor,
    dynamicProps,
    entityObject,
    isListDataReLoad,
    masterTask,
    isMobileView
  } = props;

  return (
    <Fragment>
      {/*
        Modification: T2102 - Removed modalWidth={"90%"} attribute from newPopupModal and handled z-index-1999 for imageViewer module in fileViewer
        By: Devang
        Date: 27/11/2024
      */}
      <NewPopupModal operation={operation} isMobileView={isMobileView} classes="formModal" modalDisplay={('show-formPopover overflow-hidden z-index-1999')} onClose={(e) => toggleFormPopover(e)} backgroundColor={backgroundColor ? backgroundColor: "#f7f7f7"}>
        <CoreEntityDynamicFormNoModal {...props} />
      </NewPopupModal>
    </Fragment>
  );
};

export default CoreEntityDynamicForm;
